import { User as FirebaseUser } from 'firebase/auth';
import { AuthActionTypes } from '@bridebook/web/lib/auth/action-types';
import type { IDeps, IUserSerialized, TWeddingSerialized } from '@bridebook/web/lib/types';
import { saveUserProvider } from '@bridebook/web/lib/users/actions';

/* ############################################################################
 *  SIGN IN
 * ######################################################################### */

/**
 * When signing in, start setting up the user and wedding data
 */
export const userSetupStarted = () => ({
  type: AuthActionTypes.USER_SETUP_STARTED,
});

/**
 * When signing in, save our user (received from the authenticate api endpoint) to state
 * @param firebaseUser
 * @param user
 * @param wedding
 */
export const userSetupCompleted =
  (firebaseUser: FirebaseUser, user: IUserSerialized, wedding: TWeddingSerialized) =>
  ({ dispatch }: IDeps) => {
    const { providerData } = firebaseUser;
    providerData.forEach((userInfo) => {
      if (userInfo) {
        dispatch(saveUserProvider(userInfo));
      }
    });

    return {
      type: AuthActionTypes.USER_SETUP_COMPLETED,
      payload: { firebaseUser, user, wedding },
    };
  };

/**
 * After user is logged-out from state, API and Firebase
 * */
export const signOutCompleted = () => ({
  type: AuthActionTypes.SIGN_OUT_COMPLETED,
});

/**
 * Marks the start of the logout flow, before Firestore is torn down.
 * Every Firestore listener unsubscribes on this action, so nothing is left
 * attached when the client is terminated.
 */
export const firebaseSignOut = () => ({
  type: AuthActionTypes.ON_FIREBASE_SIGN_OUT,
});

/**
 * Triggered if a user is signed out from Firebase
 * */
export const isSignedOutFirebase = () => ({
  type: AuthActionTypes.USER_IS_SIGNED_OUT,
});
